import type { TemplateOnlyComponent } from '@ember/component/template-only'
import { PageHeader } from 'teacher-ui-client/components/page-header'
import { eq } from 'ember-truth-helpers'
import type {
  BlogEntry,
  ContentNode,
  TextMark,
  UnorderedListNode,
  ParagraphNode,
  TextNode,
} from 'teacher-ui-client/subscription-type/blog/post/route'

interface BlogPostArgs {
  model: BlogEntry
}

export const BlogPost: TemplateOnlyComponent<BlogPostArgs> = <template>
  <PageHeader>
    <:title>
      <h1>{{@model.fields.title}}</h1>
    </:title>
  </PageHeader>
  <div class="mx-auto flex w-1/2 flex-col gap-y-2 pt-10">
    {{#each @model.fields.body.content as |node|}}
      {{#if (isParagraphNode node)}}
        <ParagraphNode @node={{node}} />
      {{/if}}
      {{#if (isUnorderedListNode node)}}
        <UnorderedListNode @node={{node}} />
      {{/if}}
    {{/each}}
  </div>
</template>

const UnorderedListNode: TemplateOnlyComponent<{ node: UnorderedListNode }> = <template>
  <ul class="list-inside list-disc">
    {{#each @node.content as |listItem|}}
      <li>{{#each listItem.content as |para|}}
          {{#each para.content as |textNode|}}
            <TextNode @node={{textNode}} />
          {{/each}}
        {{/each}}
      </li>
    {{/each}}
  </ul>
</template>

const ParagraphNode: TemplateOnlyComponent<{ node: ParagraphNode }> = <template>
  <p>
    {{#each @node.content as |textNode|}}
      {{#if (eq textNode.nodeType "text")}}
        <TextNode @node={{textNode}} />
      {{/if}}
    {{/each}}
  </p>
</template>

const TextNode: TemplateOnlyComponent<{ node: TextNode }> = <template>
  <span class={{marksToClasses @node.marks}}>{{@node.value}}</span>
</template>

function marksToClasses(marks: TextMark[]): string {
  return marks
    .map((mark) => {
      switch (mark.type) {
        case 'bold':
          return 'font-bold'
        case 'italic':
          return 'italic'
        case 'underline':
          return 'underline'
        default:
          return ''
      }
    })
    .join(' ')
}

function isParagraphNode(node: ContentNode): node is ParagraphNode {
  return node.nodeType === 'paragraph'
}

function isUnorderedListNode(node: ContentNode): node is UnorderedListNode {
  return node.nodeType === 'unordered-list'
}
